import React, { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
// import styled from 'styled-components';

import { Notification as VDSNotification } from '@vds/notifications';

import logger from '../../ErrorBoundary/logger_new';
// import { appLayoutLeftMargin } from '../../../../assets/css/preprocess/global.scss';
// import { desktopQuery } from '../../styles';
import { propsVal, defaultPropsVal } from '../commonHelper';
import NotificationWrapper from '../../NotificationWrapper';
import { isWHWP2 } from '../../Helpers';
import { eventDispatcher } from '../../Tagging';

const Notification = (props) => {
  const { renderIf } = props;

  useEffect(() => {
    const { serviceInfo, log, type } = props;
    if (serviceInfo && log && type === 'error') {
      logNotification();
    }
  }, [props.serviceInfo]);

  useEffect(()=>{
    if( isWHWP2() && props.location.pathname?.includes('addons') && props.renderIf){
      eventDispatcher('sendData', {
        name: '',
        svars: {
          evar13: props?.title || '',
          evar22: 'message displayed',
        },
      });
    }

  }, [props.title])

  if (!renderIf) {
    return null;
  }

  const logNotification = () => {
    const { children, logService, disableVideoAssist } = props;

    if (children) {
      const elem = document.createElement('div');
      elem.innerHTML = ReactDOMServer.renderToStaticMarkup(children);
    }
    logger({
      message: props.title,
      eventType: 'FeError',
      networkError: logService ? props.serviceInfo : undefined,
      errorName: '',
      notification: true,
      note: props.note,
      disableVideoAssist,
    });
  };

  return (
    <NotificationWrapper>
      <VDSNotification
        type={props.type}
        title={props.title}
        subtitle={props.subtitle}
        hideCloseButton={props.hideCloseButton}
        disableAnimation={props.disableAnimation}
        fullBleed={props.fullBleed}
        // className={props.className}
        onCloseButtonClick={props.onCloseButtonClick}
        buttonData={props.buttonData}
        layout={props.layout}
        // deepNested={props.deepNested}
        viewport={window?.screen?.availWidth < 769 ? 'mobile' : 'desktop'}
      />
    </NotificationWrapper>
  );
};

const valOfProps = propsVal();
const valOfDefaultProps = defaultPropsVal();

Notification.defaultProps = {
  ...valOfDefaultProps,
};

Notification.propTypes = {
  ...valOfProps,
};

const mapStateToProps = (state, ownProps) => ({
  serviceInfo: state?.serviceInfo || ownProps.serviceInfo,
});

const withConnect = connect(mapStateToProps);

export default withRouter(compose(withConnect)(Notification));
